/**
 * @desc Store modules entrance
 * @author Jooger <iamjooger@gmail.com>
 * @date 1 Dec 2017
 */

'use strict'

import * as auth from './auth'
import * as power from './power'
import * as prvateConsultation from './privateConsultation'
import * as InitiateTreatment from './InitiateTreatment'
import * as im from './im'

export default {
  auth: getModule(auth),
  power: getModule(power),
  prvateConsultation: getModule(prvateConsultation),
  InitiateTreatment: getModule(InitiateTreatment),
  im: getModule(im),
}

function getModule (mod = null) {
  if (!mod) {
    return null
  }
  return {
    namespaced: true,
    ...mod
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js